import { Injectable } from '@angular/core';
  
@Injectable()
export class SoundService {


  playAudio : boolean;

  constructor() {
    var savedSetting = (localStorage.getItem('playAudio') === 'true');
    this.playAudio = savedSetting;

   }

  toggleAudio() {
    this.playAudio = !this.playAudio;
    localStorage.setItem('playAudio', this.playAudio.toString());
    return this.playAudio;
  }

  // Sound Effects
  sellOrderFilledSound = function() {
    if(this.playAudio) {
      var audio = new Audio('../../assets/audio/Cash_Register.mp3');
      audio.play();
    }
  };

  buyOrderFilledSound = function() {
    if(this.playAudio) {
      var audio = new Audio('../../assets/audio/pin_drop.mp3');
      audio.play();
    }
  };

  resetOrdersSound = function() {
    if(this.playAudio) {
      var audio = new Audio('../../assets/audio/Pop_Cork.mp3');
      audio.play();
    }
  };

  errorSound = function() {
    if(this.playAudio) {
      var audio = new Audio('../../assets/audio/Explosion.mp3');
      audio.play();
    }
  };

  firstSoundCheck = true;
  checkLogForSound(log) {
    console.log('checking for sound', log);

    if(this.firstSoundCheck){
      this.firstSoundCheck = false;
      return;
    }

    if(!log || !log.message){
      return;
    }

    let message = log.message;

    if(typeof message != typeof "string")
    {
      return;
    }

    if( message.includes('Resetting orders')) {
      console.log('RESETTING ORDERS');
      this.resetOrdersSound();
    } else if ( message.includes('Sell Order Filled') ) {
      console.log('SELL ORDER FILLED!!!');
      this.sellOrderFilledSound();
    } else if ( message.includes('Buy Order Filled') ) {
      console.log('BUY ORDER FILLED!!!');
      this.buyOrderFilledSound();
    }

  }
}



// WEBPACK FOOTER //
// C:/Users/mybrokenwalls/workspace/mybrokenwalls/portfolio/src/app/services/sound.service.ts